import { useMemo } from 'react';

import { isSafari } from 'utilities/device';

import { useMatchMobileOnly } from 'hooks/useMatchMedia';

export const usePersistentRecordAllowed = (): boolean => {
  const isMobile = useMatchMobileOnly();

  const experimentIsAllowed = useMemo<boolean>(
    () => !(isMobile || isSafari),
    [isMobile]
  );

  return experimentIsAllowed;
};
